import { Component, HostBinding, OnInit } from '@angular/core';
import { WebsiteSaleService } from '../../projects/shared-lib/src/lib/services/website-sale.service';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { OverlayContainer } from '@angular/cdk/overlay';
import { environment } from '../../environments';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BreakpointsLib } from '../../projects/shared-lib/src/lib/utils/const-system';
import { SeatMapService } from '../../projects/shared-lib/src/lib/component/seats-map/seat-map.service';
import { subBreakpointObserver } from '../../projects/shared-lib/src/lib/utils/action';
import { IconEnregistreService } from '../../projects/shared-lib/src/lib/services/icon-enregistre.service';
import { SymplifyCartService } from '../../projects/shared-lib/src/lib/services/symplify-cart.service';
import { ClarityService } from '../../projects/shared-lib/src/lib/component/microsoftClarity/clarity.service';
import { RedirectUrlService } from './redirect-url.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigWebsite } from '../../projects/shared-lib/src/lib/models/config-website';

@Component({
    selector: 'tw-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false,
})
export class AppComponent implements OnInit {
    showApp = false;
    errorPage: any;
    response = false;
    @HostBinding('class') componentCssClass;
    configWeb: ConfigWebsite;
    constructor(
        public websiteSaleService: WebsiteSaleService,
        public overlayContainer: OverlayContainer,
        public translate: TranslateService,
        public l: Location,
        public breakpointObserver: BreakpointObserver,
        public seatMapService: SeatMapService,
        public IconEnregistreService: IconEnregistreService,
        private symplifyCartService: SymplifyCartService,
        private clarityService: ClarityService,
        private redirectUrlService: RedirectUrlService,
        private router: Router,
    ) {}

    async ngOnInit() {
        //console.log('entre ------------------------- 1211212');
        await this.IconEnregistreService.registerAllSvgIcons();
        if (environment.systemValues.search('feq') != -1) {
            this.onSetTheme('feq-theme');
        }
        if (environment.systemValues.search('tkp') != -1) {
            this.onSetTheme('tkp-theme');
            try {
                setTimeout(async () => {
                    //await injectMazeSnippet('3d33e23e-683c-40b7-81e8-1ae2e7a067f6')
                }, 1200);
            } catch (e) {}
        }
        if (environment.systemValues.search('mta') != -1) {
            this.onSetTheme('mta-theme');
        }
        if (environment.systemValues.search('spec') != -1) {
            this.onSetTheme('spec-theme');
        }
        if (window.location.hostname.search('local.com') != -1) {
            environment.production = false;
            environment.checkout = false;
        }

        try {
            await this.websiteSaleService.getConfigWeb();
            this.configWeb = this.websiteSaleService.getLocalConfig();
            this.redirectUrlService._url.asObservable().subscribe((value) => {
                /*** redirect url **/
                //console.log(value);
                if (value.length > 0) {
                    if (this.configWeb && this.configWeb.cartRedirectionUrl) {
                        try {
                            if (this.configWeb.cartRedirectionUrl && this.configWeb.cartRedirectionUrl.search('{') !== -1) {
                                this.configWeb.cartRedirectionUrl = this.configWeb.cartRedirectionUrl.replace(
                                    '{}',
                                    this.translate.currentLang,
                                );
                            }
                            window.location.href = this.configWeb.cartRedirectionUrl;
                        } catch (e) {
                            //console.log(e);
                        }
                    } else {
                        this.router.navigate([this.translate.currentLang + '/pages']);
                    }
                }
            });
            this.showApp = true;
            this.response = true;
            await this.symplifyCartService.init(this.translate.currentLang);
            await this.symplifyCartService.initWebTracking(this.translate.currentLang);
        } catch (error1) {
            this.showApp = false;
            this.errorPage = error1;
            this.response = true;
        }
        const layoutChanges = this.breakpointObserver.observe([
            Breakpoints.XSmall,
            BreakpointsLib.MediumMobile,
            Breakpoints.Small,
            Breakpoints.Medium,
            Breakpoints.Large,
            Breakpoints.XLarge,
        ]);
        layoutChanges.subscribe((result) => {
            console.log(result);
            subBreakpointObserver.next(result);
        });
        const e = this.seatMapService.watchSeatSelected().subscribe((value) => {
            if (!value) {
            }
        });
        await this.clarityService.init();
    }

    onSetTheme(theme) {
        // console.log(theme);
        this.overlayContainer.getContainerElement().classList.add(theme);
        this.componentCssClass = theme;
    }
}
